import React, { useRef, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Typography, useTheme } from "@mui/material";
import FeedbackIcon from "@mui/icons-material/Feedback";
import PropTypes from "prop-types";

import { CONSUMER, allAdminRoles } from "common/constant";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";
import { isAuthorizedUser } from "utils";

import darkThemeLoadingGIF from "assets/images/loading-dark.gif";
import giftCityIcon from "assets/images/svg/logo-dark.svg";
import loadingGIF from "assets/images/loading.gif";

import {
  ConversationBox,
  Loader,
  MessageBox,
  NoConversationBox,
  QuestionOptionBox,
  StyledAvatar,
} from "./styles";

const Conversation = ({
  conversationResponses = [],
  isLoading = false,
  handleSelect = () => {},
  t,
}) => {
  const theme = useTheme();
  const { roles, isLoggedIn } = useSelector((state) => state.Login);

  const scrollableContainerRef = useRef(null);

  useEffect(() => {
    scrollableContainerRef.current.scroll({
      top: scrollableContainerRef.current.scrollHeight,
    });
  }, []);

  return (
    <ConversationBox ref={scrollableContainerRef}>
      {conversationResponses.length
        ? conversationResponses.map((message, index) =>
            message.adminMessage ? (
              <React.Fragment key={index}>
                <div className="d-flex justify-content-start align-items-center">
                  {(roles.includes(CONSUMER) || !isLoggedIn) && (
                    <StyledAvatar src={giftCityIcon} />
                  )}
                  <MessageBox isAdmin>
                    {message.userName && message.commentDateTime && (
                      <>
                        <Typography variant="subtitle2">
                          {message.userName}
                        </Typography>
                        <Typography variant="subtitle2">
                          {convertUTCDateToLocalDate(
                            message.commentDateTime
                          ).format("DD-MM-YYYY hh:mm:ss A")}
                        </Typography>
                      </>
                    )}
                    {message.adminMessage}
                  </MessageBox>
                </div>
                {message.options &&
                  message.options.map((option) => (
                    <QuestionOptionBox
                      key={option.id}
                      onClick={() =>
                        handleSelect(message.questionId, option.id)
                      }
                    >
                      {option.name}
                    </QuestionOptionBox>
                  ))}
              </React.Fragment>
            ) : (
              <React.Fragment key={index}>
                <div className="d-flex justify-content-end align-items-center">
                  <MessageBox isAdmin={false}>
                    {message.userName && message.commentDateTime && (
                      <>
                        <Typography variant="subtitle2">
                          {message.userName}
                        </Typography>
                        <Typography variant="subtitle2">
                          {convertUTCDateToLocalDate(
                            message.commentDateTime
                          ).format("DD-MM-YYYY hh:mm:ss A")}
                        </Typography>
                      </>
                    )}
                    {message.clientMessage}
                  </MessageBox>
                  {isAuthorizedUser(roles, allAdminRoles) ? (
                    <StyledAvatar src={giftCityIcon} />
                  ) : null}
                </div>
              </React.Fragment>
            )
          )
        : !isLoading && (
            <NoConversationBox>
              <FeedbackIcon color="disabled" />
              <Typography color="GrayText" ml="10px">
                {t("No conversation started yet")}
              </Typography>
            </NoConversationBox>
          )}
      {isLoading && (
        <div className="d-flex gap-2 mt-3">
          <StyledAvatar src={giftCityIcon} />
          <Loader
            src={
              theme.palette.mode === "dark" ? darkThemeLoadingGIF : loadingGIF
            }
            className="mt-1"
            alt="Loading-Gif"
          />
        </div>
      )}
    </ConversationBox>
  );
};

Conversation.propTypes = {
  conversationResponses: PropTypes.array,
  isLoading: PropTypes.bool,
  handleSelect: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(Conversation);
